import { BuilderComponent } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { FC, useEffect } from 'react';

import { getBlockDataMap } from '../builder';
import Breadcrumb, { BreadcrumbItem } from '../components/breadcrumb/breadcrumb';
import DefaultLayout from '../components/layouts/default-layout';
import MetaBlock from '../components/meta-block/MetaBlock';
import NewsletterSignUpSection from '../components/newsletter-signup-section/newsletter-signup-section';
import { BusinessTheme } from '../contexts/LayoutContext';
import * as style from '../styles/generic.module.scss';

const BusinessResourceLayout = dynamic(() => import('../components/layouts/business-resouce-layout'));

interface Props {
    page: any;
}

export const MainPage: FC<Props> = (props) => {
    const { page } = props;

    let breadcrumbs: BreadcrumbItem[] = [
        {
            name: 'Business',
            link: '/business',
        },
        {
            name: page?.name || '',
            link: '',
        },
    ];
    if (page?.data?.breadcrumbs) {
        breadcrumbs = page.data.breadcrumbs.map((data: any) => ({ name: data.name, link: data.link ?? data.url }));
    }
    const breadcrumbsType: 'light' | 'dark' = page?.data?.darkTheme ? 'light' : 'dark';
    useEffect(() => {
        const body = document.body;
        if (!body) {
            return;
        }
        if (page?.data?.darkTheme) {
            body.classList.add('dark');
        } else {
            body.classList.remove('dark');
        }
    }, [page?.data?.darkTheme]);

    const layout: BusinessTheme = page?.data?.layout;

    return (
        <DefaultLayout breadcrumbs={breadcrumbs}>
            <MetaBlock title={page?.data?.title} description={page?.data?.description}>
                <link rel="icon" href="/ap-favicon.ico" />
            </MetaBlock>
            <div className={(style as any)['page-layout']}>
                {layout === BusinessTheme.MARKETING_RESOURCE ? (
                    <BusinessResourceLayout>
                        <BuilderComponent model="page" content={page} data={getBlockDataMap(page)} />
                    </BusinessResourceLayout>
                ) : (
                    <>
                        {!page?.data?.hideDefaultBreadcrumbs && <Breadcrumb breadcrumbs={breadcrumbs} type={breadcrumbsType || 'dark'} />}
                        <BuilderComponent model="page" content={page} data={getBlockDataMap(page)} />
                    </>
                )}
            </div>
            {layout === BusinessTheme.MARKETING_RESOURCE ? null : <NewsletterSignUpSection />}
        </DefaultLayout>
    );
};
